module.exports = __webpack_public_path__ + "img/77348.8b7e682a.svg";